export default {
	dayHeight: 25,
	calendarWidth: 400,

	formatNoTime: "MMMM d yyyy",
	formatWithTime: "MMMM d yyyy h:mm a",

	displayFormat(hasTime: boolean) {
		return hasTime ? this.formatWithTime : this.formatNoTime;
	},

	timeOptions: [
		{ label: "Midnight", value: 0 },
		{ label: "9:00 am", value: 9 },
		{ label: "Noon", value: 12 },
		{ label: "5:00 pm", value: 17 },
	],
};
